import { fetchWithToken } from '@platform/core/auth';

export type AuthContextValue = {
  fetchApi: WindowOrWorkerGlobalScope['fetch'];
  logout: () => void;
};

export const useAuthContext = (): AuthContextValue => {
  return {
    fetchApi: fetchWithToken,
    logout: () => {
      throw new Error('logout must not be called in UP.IA');
    },
  };
};

export { useGetUserInfo } from '@platform/client/auth/use-get-user-info';
export { useGetToken } from '@platform/client/auth/use-get-token';
